<template>
  <div class="box">
    <h3>Order Details</h3>
    <div class="table">
      <template>
        <template v-if="isHDRedeem">
          <div
            v-for="(item, index) in hdList"
            :key="index"
            class="tr">
            <span>{{ item.label }}</span>
            <span>{{ form[item.val] }}</span>
          </div>
        </template>
        <template v-else>
          <div
            v-for="(item, index) in list"
            :key="index"
            class="tr">
            <span>{{ item.label }}</span>
            <span>{{ form[item.val] }}</span>
          </div>
          <div class="tr">
            <span>Receipt</span>
            <span>
              <a
                :href="url"
                class="download"
                @click="download">Download</a>
            </span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {downloadFileName} from '@/utils/download'
export default {
  name: 'OrderDetail',
  props:{
    form:{
      type: Object,
      default: {}
    },
    isHDRedeem:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list:[
        {
          label: 'Last Name',
          val: 'isrd_lst_nm'
        },
        {
          label: 'First Name',
          val: 'isrd_fst_nm'
        },
        {
          label: 'Date of Birth',
          val: 'isrd_dob_date'
        },
        {
          label: 'Mobile Number',
          val: 'mobile_no'
        },
        {
          label: 'Locker ID',
          val: 'sf_locker'
        },
        {
          label: 'Amount',
          val: 'buy_num'
        },
        {
          label: 'Price',
          val: 'amount'
        },
      ],
      hdList:[
        {
          label: 'Last Name',
          val: 'isrd_lst_nm'
        },
        {
          label: 'First Name',
          val: 'isrd_fst_nm'
        },
        {
          label: 'Mobile Number',
          val: 'mobile_no'
        },
        {
          label: 'Home Address',
          val: 'addr'
        }
      ],
    }
  },
  computed:{
    url(){
      if(this.form && this.form.rec_pdf){
        return this.form.rec_pdf.url
      }
      return ''
    }
  },
  methods:{
    download(e){
      e.preventDefault()
      console.log(this.form.rec_pdf.url)
      downloadFileName(this.form.rec_pdf.url,'Receipt.pdf')
    }
  }
}
</script>
<style lang='scss' scoped>
.box {
  margin-bottom: 10px;
  h2 {
    padding-bottom: 5px;
  }
  .download{
    text-decoration: none;
    color: rgb(0, 0, 238);
    cursor: pointer;
  }
}
</style>
